// extracted by mini-css-extract-plugin
module.exports = {"title":"pukq4X","description":"c6l2_LC","link":"c-tR4cc","name":"O2uEuo"};